import {useSession} from "../../../redux/Reducers/AuthReducer";
import testFunc from "../../../../script/testFunc";
import {GoTriangleRight} from "react-icons/go";
import {Link, useNavigate} from "react-router-dom";
import PrimaryButton from "../../../components/Buttons/primary-button";


export default function Poster({className, ...props}) {
    const navigate = useNavigate();

    return (
        <div id={"home"}
             className={"flex flex-col p-[30px] box-border md:p-[80px] justify-center items-center md:flex-row gap-[20px] md:gap-[41px] "}>


            <div className={"flex flex-col w-full md:max-w-[783px] gap-[12px] md:gap-[56px]"}>
                <div className={"flex flex-col gap-[12px] md:gap-[24px]"}>
                    <p
                        style={{
                            lineHeight: "120%"
                        }}
                        className={"font-bold  text-2xl md:text-[64px]"}>
                        Reach Your <span className={"text-[#0C98FE]"}>Best Duolingo</span> English Test Score with
                        Instant AI Feedback
                    </p>
                    <p
                        style={{
                            lineHeight: "160%"
                        }}
                        className={"font-semibold text-md  md:text-[24px]"}>
                        Practice smarter with AI evaluations, detailed templates, and 15,000+ real DET-style questions
                        you won't find on any other platform
                    </p>

                </div>

                <div className={"w-full md:w-auto flex flex-col md:flex-row gap-4"}>
                    <PrimaryButton
                        onClick={() => navigate("/practice")}
                    >
                        Start Practicing Free
                    </PrimaryButton>
                    <PrimaryButton
                        variant={"reverse"}
                        onClick={() => navigate("/pricing/vip")}

                    >
                        View Plans & Pricing
                    </PrimaryButton>
                </div>
            </div>

            <img

                src={'/images/online-education.svg'}
                alt={"Hero Section Image"}
                className={"w-full md:w-[664px] h-auto"}
            />

        </div>
    )

}
